import React, { useState } from 'react'
import { useMutation } from '@apollo/react-hooks'
import { useIntl } from 'react-intl'
import { Link, useHistory } from 'react-router-dom'
import { Checkbox, Grid } from 'semantic-ui-react'
import { Form, FormContext, InputField, CheckboxField, SubmitButton, validate } from '@labsavvyapp/ui-components'

import { useApolloClient } from '@apollo/react-hooks'
import { HOME, SIGN } from '../../../config/routes'
import { setCookie } from '../../../utils/auth'
import { GetSession } from '../../../graphql/user/queries.js'
import { Login } from '../../../graphql/user/mutations.js'
import style from './SignInPage.module.css'
import { Button, LabsavvyIQLogo, PasswordInput, TextInput, useForm } from '@labsavvyapp/components'

function SignInPage() {
  const { formatMessage } = useIntl()
  const client = useApolloClient()

  const { push } = useHistory()
  const [login, { error: loginError }] = useMutation(Login, {
    update(cache, { data }) {
      const { tokens } = data.login
      setCookie(tokens.access)

      cache.writeQuery({
        query: GetSession,
        data: {
          session: {
            __typename: 'Session',
            token: tokens.access,
            isLoggedIn: true,
          },
        },
      })
    },
  })
  const [formErrors, setFormErrors] = useState({})

  const form = useForm({
    initialValues: {
      email: null,
      password: null,
    },
    validate: {
      email: (value) => (value.length < 1 ? 'Cannot be empty' : null),
      password: (value) => (value.length < 1 ? 'Cannot be empty' : null),
    },
  })

  const onLogin = async ({ email, password }) => {
    try {
      await login({ variables: { email, password } })
      client.resetStore()
      push(HOME)
    } catch (error) {
      if (error?.graphQLErrors?.[0]?.message) {
        // FIXME: Create a custom instance for handling i18n errors (https://labsavvy.atlassian.net/browse/LS-511)
        const serverError = new Error(
          JSON.stringify({
            id: 'server_error',
            defaultMessage: error.graphQLErrors[0].message,
          }),
        )
        setFormErrors({
          email: serverError,
          password: serverError,
        })
      }
    }
  }

  const handleResetFormErrors = () => {
    if (Object.keys(formErrors).length > 0) {
      setFormErrors({
        email: null,
        password: null,
      })
    }
  }

  return (
    <div className={style.container}>
      <form onSubmit={form.onSubmit(onLogin)}>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <LabsavvyIQLogo />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <TextInput
                name="email"
                placeholder="Email"
                onChange={() => handleResetFormErrors()}
                {...form.getInputProps('email')}
                error={loginError && ' '}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <PasswordInput
                name="password"
                placeholder="Password"
                onChange={handleResetFormErrors}
                {...form.getInputProps('password')}
                error={loginError && 'Invalid email/password'}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Checkbox name="remember_me" label="Remember Me" />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <div className={style.buttons}>
                <Button onClick={() => {}} radius="xl" size="md" uppercase variant="filled" type="submit" fullWidth>
                  Sign in
                </Button>
                <Link className={style.forgotPasswordLink} to={SIGN.recover}>
                  Forgot password?
                </Link>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </form>
    </div>
  )
}

export default SignInPage
